module.exports = __webpack_public_path__ + "img/meal.3d94d322.png";